import { SiteHeader } from "../components/site-header"

export function TermsPage() {
  return (
    <div className="site-frame">
      <SiteHeader />
      <main className="simple-page legal-copy">
        <div className="eyebrow">Terms</div>
        <h1>Terms of service</h1>
        <p>Effective date: April 28, 2026</p>

        <h2>1. Agreement to terms</h2>
        <p>
          These Terms of Service govern access to and use of the Adgiro website, application, and
          related services. By accessing or using the service, the customer agrees to these Terms of
          Service on behalf of the customer and any entity the customer represents.
        </p>

        <h2>2. Service description</h2>
        <p>
          Adgiro provides software tools and related services for advertising account connection,
          website event collection, conversion measurement, campaign creation, reporting, campaign
          operations, and automation workflows.
        </p>

        <h2>3. Eligibility and authority</h2>
        <p>
          The customer represents that the customer has the legal capacity and authority to enter
          into these Terms of Service and to authorize Adgiro to access, read, create, modify, and
          manage connected advertising and analytics resources in accordance with the permissions
          selected by the customer.
        </p>

        <h2>4. Account registration and security</h2>
        <p>
          The customer is responsible for maintaining accurate account information, safeguarding
          credentials, controlling access to the workspace, and promptly updating any information
          that affects billing, permissions, or operational authority.
        </p>

        <h2>5. Connected accounts and customer instructions</h2>
        <p>
          By connecting third-party accounts or services, the customer authorizes Adgiro to perform
          actions through those services consistent with the product features, settings, and
          operating modes selected by the customer. The customer is responsible for reviewing
          scopes, budget controls, permissions, account mappings, and campaign settings.
        </p>

        <h2>6. Fees and payment</h2>
        <p>
          Fees, billing intervals, renewal terms, support tiers, and related commercial terms are
          presented in the Adgiro pricing and checkout flow or in a separate order form. Charges
          become due in accordance with the applicable billing terms.
        </p>

        <h2>7. Customer responsibilities</h2>
        <p>The customer agrees to:</p>
        <ul className="legal-list">
          <li>
            Use the service in compliance with applicable law, platform policies, and contractual
            obligations.
          </li>
          <li>
            Provide accurate configuration data, connected account data, and website implementation
            data.
          </li>
          <li>
            Review campaign settings, budget controls, approval flows, and automation permissions.
          </li>
          <li>
            Maintain all required notices, disclosures, and rights necessary for event collection
            and ad platform use.
          </li>
        </ul>

        <h2>8. Acceptable use</h2>
        <p>
          The customer may use the service solely for lawful business purposes. The customer may
          refrain from using the service in a manner that interferes with the platform, introduces
          malicious code, violates the rights of others, circumvents security controls, or breaches
          third-party platform rules.
        </p>

        <h2>9. Intellectual property</h2>
        <p>
          Adgiro and its licensors retain all right, title, and interest in and to the service,
          including software, interfaces, workflows, branding, content, and related intellectual
          property. Subject to these Terms of Service, Adgiro grants the customer a limited,
          non-exclusive, revocable right to access and use the service during the subscription term.
        </p>

        <h2>10. Confidentiality and data handling</h2>
        <p>
          Each party may receive confidential information from the other party in connection with
          the service. Each party agrees to use the other party’s confidential information solely
          for the purposes of the business relationship and to protect that information using
          reasonable care.
        </p>

        <h2>11. Suspension and termination</h2>
        <p>
          Adgiro may suspend or terminate access to the service in response to security concerns,
          payment issues, legal compliance needs, platform policy issues, or material breach of
          these Terms of Service. The customer may discontinue use of the service and close the
          account in accordance with the product workflow or written notice process then in effect.
        </p>

        <h2>12. Warranty disclaimer</h2>
        <p>
          The service is provided on an as-available basis. Adgiro disclaims warranties to the
          fullest extent permitted by applicable law, including warranties relating to
          merchantability, fitness for a particular purpose, title, accuracy, availability, and
          uninterrupted performance.
        </p>

        <h2>13. Limitation of liability</h2>
        <p>
          To the fullest extent permitted by applicable law, Adgiro’s aggregate liability arising
          out of or relating to the service or these Terms of Service will be limited to the amounts
          paid by the customer to Adgiro for the service during the twelve months preceding the
          event giving rise to the claim. Adgiro will have no liability for indirect, incidental,
          consequential, special, exemplary, or punitive damages, or for loss of profits, revenue,
          goodwill, data, or business opportunity.
        </p>

        <h2>14. Indemnification</h2>
        <p>
          The customer agrees to indemnify, defend, and hold harmless Adgiro and its officers,
          directors, employees, contractors, and agents from and against claims, liabilities,
          damages, losses, and expenses arising out of or relating to the customer’s use of the
          service, the customer’s connected accounts, the customer’s data, or the customer’s breach
          of these Terms of Service.
        </p>

        <h2>15. Governing law</h2>
        <p>
          These Terms of Service are governed by the law specified in the applicable order form,
          company policy, or service documentation then in effect. Venue for disputes will lie in
          the courts designated by that governing law framework, subject to mandatory legal
          requirements.
        </p>

        <h2>16. Changes to these terms</h2>
        <p>
          Adgiro may revise these Terms of Service from time to time. Revised versions may be posted
          on this page together with a revised effective date.
        </p>

        <h2>17. Contact</h2>
        <p>
          Questions regarding these Terms of Service may be directed to the contact address
          identified in the Adgiro application or company materials.
        </p>
      </main>
    </div>
  )
}
